/**
 * Device authentication utilities
 * Manages device tokens stored in cookies
 */

const DEVICE_TOKEN_KEY = 'device_token';
const COOKIE_EXPIRY_DAYS = 365; // 1 year

/**
 * Set a cookie
 */
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
}

/**
 * Get a cookie value
 */
function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Delete a cookie
 */
function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

/**
 * Get the device token from cookie
 */
export function getDeviceToken() {
  return getCookie(DEVICE_TOKEN_KEY);
}

/**
 * Set the device token in cookie
 */
export function setDeviceToken(token) {
  setCookie(DEVICE_TOKEN_KEY, token, COOKIE_EXPIRY_DAYS);
}

/**
 * Remove the device token
 */
export function removeDeviceToken() {
  deleteCookie(DEVICE_TOKEN_KEY);
}

/**
 * Generate a device fingerprint based on browser/system info
 * This is a simple implementation - you can enhance it with libraries like fingerprintjs
 */
export function getDeviceFingerprint() {
  const nav = window.navigator;
  const screen = window.screen;
  
  const fingerprint = {
    userAgent: nav.userAgent,
    language: nav.language,
    platform: nav.platform,
    screenResolution: `${screen.width}x${screen.height}`,
    colorDepth: screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  // Create a simple hash of the fingerprint
  return btoa(JSON.stringify(fingerprint));
}

/**
 * Check if device token exists
 */
export function hasDeviceToken() {
  return !!getDeviceToken();
}
